import React from 'react';
import SearchAutoSuggest from './SearchAutoSuggest';

const InputWithAutocomplete = ({
  title,
  suggestions,
  searchTerm,
  setSeachTerm,
  isDropdown,
  disabled,
}) => (
  <div className="column">
    <div className="field">
      <div className="label">
        <label htmlFor="" className="label">
          {title}
        </label>
      </div>
      <div className="field-body">
        <div className="field">
          <SearchAutoSuggest
            disabled={disabled}
            suggestions={suggestions}
            searchTerm={searchTerm}
            setSeachTerm={setSeachTerm}
            isDropdown={isDropdown}
          />
        </div>
      </div>
    </div>
  </div>
);

export default InputWithAutocomplete;
